import(/* webpackMode: "eager" */ "/Users/joseph/projects/moneyline/client/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/joseph/projects/moneyline/client/src/app/(public)/[sport]/teams/[team]/[year]/sidebar.tsx");
;
import(/* webpackMode: "eager" */ "/Users/joseph/projects/moneyline/client/src/components/primitives/button.tsx");
